import { renderExpr } from 'common/soql_builder/expr';
import functions from 'common/soql_builder/function';
import { encodeStringAsColumnRef } from 'common/soql_builder/util';

/**
 * Renders the SoQL expression for the url text of a url column (`` `column`.url ``), since a url
 * cell is a { url, description } object that can't be compared to a plain string.
 * @param columnName The column's field name, unencoded.
 */
export function renderUrlSubfield(columnName: string): string {
  const columnRef = encodeStringAsColumnRef(columnName.replace(/-/g, '_'));

  return renderExpr(functions.url_url(columnRef));
}
